import { render, staticRenderFns } from "./VendorDetailDialog.vue?vue&type=template&id=5b2d8f9c&"
import script from "./VendorDetailDialog.vue?vue&type=script&lang=js&"
export * from "./VendorDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetailDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports